import { API } from '../../../api';
import { Alert, Button, Col, Input, Result, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

class CreateNewSchema extends React.Component {
  static propTypes = {
    client: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
    next: PropTypes.func.isRequired,
  };

  state = {
    errorMsg: '',
    fileSchemaName: '',
    inputStatus: '',
  };

  onChange = e => {
    this.setState({ fileSchemaName: e.target.value });
  };

  /**
   * Indicate to the user that there was a problem with the input.
   */
  setInputError(msg) {
    this.setState({
      errorMsg: msg,
      inputStatus: 'error',
    });
  }

  moveToNextStep = () => {
    const { next } = this.props;
    const { fileSchemaName } = this.state;
    next(fileSchemaName);
  };

  /**
   * Send request to see if file with the given name already exists.
   */
  fileExists = async fileName => {
    const { client } = this.props;
    const params = {
      archived: false,
      client_id: client.id,
      name: fileName,
    };
    const fileResponse = await API.get('/file', { params });
    return fileResponse.data.files.length > 0;
  };

  /**
   * Called when the user clicks button to finish this step.
   */
  btnClick = async () => {
    const { fileSchemaName } = this.state;

    if (fileSchemaName === '') {
      this.setInputError('The file schema name can not be empty.');
      return;
    }

    if (await this.fileExists(fileSchemaName)) {
      this.setInputError(
        `A schema with the name ${fileSchemaName} already exists for this client.`,
      );
      return;
    }

    this.moveToNextStep();
  };

  render() {
    const { errorMsg, inputStatus } = this.state;
    return (
      <>
        <Row style={{ marginTop: 20, marginBottom: 20 }} align="middle" gutter={[16, 16]}>
          <Col>
            <p>
              Before creating a mapping, please create a file schema to associate with a FHIR
              resource mapping.
            </p>
            <Alert
              type="info"
              description={
                <>
                  <h3>Why do I need to create a schema?</h3>
                  <p>
                    A file schema is used to link a FHIR mapping to a data source, like a CSV or
                    NDJSON file. Every FHIR mapping is associated with at least one file schema.
                    However, one file schema may be mapped to multiple FHIR resources.
                  </p>
                  <p>
                    The name of the schema should be the generic name of the table/file. For
                    example, if files are sent with a prefixes or suffixes (
                    <code className="code-green">1up_patient_extract_04022022.csv</code>) then an
                    ideal name for the schema would be <code className="code-green">patient</code>.
                  </p>
                </>
              }
            />
          </Col>
        </Row>
        <Row align="middle" gutter={[16, 16]}>
          <Col span={12} align="start">
            <Input
              addonBefore="Name:"
              id="file-schema-input"
              onChange={this.onChange}
              status={inputStatus}
              style={{ width: '80%', marginRight: 5 }}
            />
            <Button onClick={() => this.btnClick()} type="primary">
              Next
            </Button>
          </Col>
        </Row>
        {errorMsg && <Result status="error" title="Invalid schema name" subTitle={errorMsg} />}
      </>
    );
  }
}

export default CreateNewSchema;
